
// // src/components/RoleSelector.tsx
// import React, { useState, useEffect } from "react";
// import styles from "./RoleSelector.module.css";

// const RoleSelector: React.FC = () => {
//     const [visible, setVisible] = useState(true);

//     const handleSelection = (event: React.ChangeEvent<HTMLSelectElement>) => {
//         const selected = event.target.value;

//         if (selected === "user") {
//             //window.location.href = "/"; // Replace with actual login URL
//             setVisible(false);
//         } else if (selected === "guest") {
//             setVisible(false); // Hide overlay for guest
//         }
//     };

//     if (!visible) return null;

//     return (
//         <div className={styles.overlay}>
//             <div className={styles.selectorBox}>
//                 <h2>Select how you want to continue</h2>
//                 <select onChange={handleSelection} defaultValue="">
//                     <option value="" disabled>
//                         -- Choose an option --
//                     </option>
//                     <option value="user">Registered User</option>
//                     <option value="guest">Guest</option>
//                 </select>
//             </div>
//         </div>
//     );
// };

// export default RoleSelector;


// import React, { useState, useEffect } from "react";
// import styles from "./RoleSelector.module.css";

// const RoleSelector: React.FC = () => {
//     const [visible, setVisible] = useState(true);
//     const [checkingAuth, setCheckingAuth] = useState(true);

//     useEffect(() => {
//         const checkAuthStatus = async () => {
//             try {
//                 const response = await fetch("/check-auth", {
//                     credentials: "include",
//                 });

//                 const data = await response.json();

//                 if (data.authenticated) {
//                     setVisible(false); // Hide overlay if already logged in
//                 }
//             } catch (error) {
//                 console.error("Auth check failed:", error);
//             } finally {
//                 setCheckingAuth(false);
//             }
//         };

//         // checkAuthStatus();
//     }, []);

//     const handleSelection = async (event: React.ChangeEvent<HTMLSelectElement>) => {
//         const selected = event.target.value;

//         if (selected === "user") {
//             // setVisible(false);
//             window.location.href = "/login"; // Redirect to login
//         } else if (selected === "guest") {
//             setVisible(false); // Hide overlay for guest
//         }
//     };

//     // if (!visible || checkingAuth) return null;
//     if (!visible) return null;

//     return (
//         <div className={styles.overlay}>
//             <div className={styles.selectorBox}>
//                 <h2>Select how you want to continue</h2>
//                 <select onChange={handleSelection} defaultValue="">
//                     <option value="" disabled>
//                         -- Choose an option --
//                     </option>
//                     <option value="user">Registered User</option>
//                     <option value="guest">Guest</option>
//                 </select>
//             </div>
//         </div>
//     );
// };

// export default RoleSelector;


import React, { useState, useEffect } from "react";
import styles from "./RoleSelector.module.css";

const RoleSelector: React.FC = () => {
  const [visible, setVisible] = useState(true);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const checkAuthStatus = async () => {
      try {
        const response = await fetch("/check-auth", {
          credentials: "include",
          // Optional but useful to avoid cached responses:
        //   headers: { "Cache-Control": "no-cache" },
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data: { authenticated?: boolean } = await response.json();

        // Show overlay only if NOT authenticated
        if (!cancelled) {
          const authenticated = Boolean(data?.authenticated);
          setVisible(!authenticated);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        // On error, default to showing the overlay
        if (!cancelled) setVisible(true);
      } finally {
        if (!cancelled) setCheckingAuth(false);
      }
    };

    // ✅ Actually run the auth check
    checkAuthStatus();

    // Cleanup in case component unmounts mid-request
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelection = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = event.target.value;

    if (selected === "user") {
      window.location.href = "/login"; // Redirect to login
    } else if (selected === "guest") {
      setVisible(false); // Hide overlay for guest
    }
  };

  // Hide the overlay while we're checking, and whenever `visible` is false
  if (checkingAuth || !visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.selectorBox}>
        <h2>Select how you want to continue</h2>
        <select onChange={handleSelection} defaultValue="">
          <option value="" disabled>
            -- Choose an option --
          </option>
          <option value="user">Registered User</option>
          <option value="guest">Guest</option>
        </select>
      </div>
    </div>
  );
};

export default RoleSelector;
